<div *ngIf="companyId">
  <app-header></app-header>



  <form *ngIf="orderForm" [formGroup]="orderForm">

    <div *ngIf="!disalbleAll">
      <br /><br />
      <mat-card *ngIf="!showWebIdInfo" class="step-card">
            <mat-card-header>
              <mat-card-title style="text-align: center;">{{"ORDER.PAYMENT.CHANGE_TITLE" | translate : {invoiceCode:this.invoiceCode, amount: this.amountFormatted } }}</mat-card-title>
              <mat-card-subtitle>{{"ORDER.PAYMENT.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

              <div [hidden]="false" style="margin-top: 10px;">


              <app-payment-type-selector [disabled]="false" [selectedProduct]="null" [wantCardName]="false" [productId]="null"
                                         [allowedPaymentMethods]="allowedPaymentMethods" formControlName="paymentType" required>
              </app-payment-type-selector>


            </div>




            </mat-card-content>
            <mat-card-actions align="end">

              <div fxFlex></div>
              <button mat-raised-button color="primary" (click)="changePayment()" *ngIf="true"
                [disabled]="orderForm.invalid">{{"BUTTON.SUBMIT" | translate}}</button>
            </mat-card-actions>
          </mat-card>

      <mat-card class="step-card" *ngIf="showWebIdInfo">
      <mat-card-header class="webid-title">
        <mat-card-title style="text-align: center" >
          {{"ORDER.SUMMARY.SUCCESS.TITLE" | translate : { firstname: this.firstName } }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="margin-left-16px" style="text-align: center;">
        <!--  <div>
            <div [innerHTML]="'ORDER.SUMMARY.SUCCESS.TEXT' | translate : { firstname: summaryPageUserAddressing?.firstName }"></div>
          </div>

          <div *ngIf="showWebIdInfo" style="margin-top: 30px;">
            {{"ORDER.SUMMARY.WEBID.INFOTEXT" | translate}}
          </div>
-->

        <div  style="min-height: 150px; margin-top: 50px; margin-bottom: 80px; text-align: center">
          <button mat-raised-button color="primary" style="font-size: 1.2em; padding: 10px 25px; font-weight: bold"
                  (click)="redirectToWebId()"
                  type="button">{{"ORDER.SUMMARY.WEBID.BUTTONTEXT" | translate}}
          </button>


        </div>

      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>
    </div>





  </form>
</div>
